module.exports = __webpack_public_path__ + "static/media/dots-active-7.01cbb0cc.svg";